// src/firebaseConfig.js
import { initializeApp } from 'firebase/app';
import { getAuth, connectAuthEmulator, GoogleAuthProvider } from 'firebase/auth';
import {
  initializeFirestore,
  connectFirestoreEmulator,
} from 'firebase/firestore';
import { getStorage } from 'firebase/storage'; // If you're using Firestore
import { getPerformance } from 'firebase/performance';
// Analytics imported dynamically below to prevent blocking
import { initializeAppCheck, ReCaptchaV3Provider, getToken as getAppCheckToken } from 'firebase/app-check'; // Import App Check

const firebaseConfig = {
  apiKey: 'AIzaSyBjLz2QL1ybwwo0YytJEwhI3u69Sqp7MhI',
  authDomain: 'kikikata.firebaseapp.com',
  databaseURL: 'https://kikikata-default-rtdb.europe-west1.firebasedatabase.app',
  projectId: 'kikikata',
  storageBucket: 'kikikata.appspot.com',
  messagingSenderId: '60396857362',
  appId: '1:60396857362:web:8cb2a4a1fa66e2773190cb',
  measurementId: 'G-0YKY18VJEX',
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Get Firebase Authentication instance
const auth = getAuth(app);

const firestore = initializeFirestore(app, {});

const storage = getStorage(app);

// Initialize performance monitoring (non-blocking)
try {
  getPerformance(app);
} catch (error) {
  console.warn('[Firebase] Performance monitoring initialization failed:', error);
}

// Initialize analytics with proper error handling (non-blocking)
import('firebase/analytics')
  .then(({ getAnalytics, isSupported }) => {
    isSupported()
      .then((supported) => {
        if (supported) {
          try {
            getAnalytics(app);
          } catch (error) {
            console.warn('[Firebase] Analytics initialization failed:', error);
          }
        } else {
          console.log('[Firebase] Analytics not supported in this environment');
        }
      })
      .catch((error) => {
        console.warn('[Firebase] Analytics support check failed:', error);
      });
  })
  .catch((error) => {
    console.warn('[Firebase] Failed to load analytics module:', error);
  });

const googleProvider = new GoogleAuthProvider();

// Check if you're in a development environment (localhost)
if (window.location.hostname === 'localhost' || window.location.hostname.startsWith('10.')) {
  // Only set debug token in development
  self.FIREBASE_APPCHECK_DEBUG_TOKEN = '4591DBBA-9741-4E20-AB39-3A8C8CEC27C9';

  // Use the Firebase Authentication emulator
  const emulatorHost = window.location.hostname;
  connectAuthEmulator(auth, `http://${emulatorHost}:9099`, { disableWarnings: true });

  // Use Firestore emulator (if using Firestore)
  connectFirestoreEmulator(firestore, emulatorHost, 8080);
}
// else {
//   self.FIREBASE_APPCHECK_DEBUG_TOKEN = '4591DBBA-9741-4E20-AB39-3A8C8CEC27C9';

//   // Use the Firebase Authentication emulator
//   connectAuthEmulator(auth, 'http://10.100.102.11:9099'); // The default emulator port for Firebase Auth

//   // Use Firestore emulator (if using Firestore)
//   connectFirestoreEmulator(firestore, '10.100.102.11', 8080); // Firestore emulator port
// }

// Initialize App Check with error handling (non-blocking)
let appCheck = null;
try {
  appCheck = initializeAppCheck(app, {
    provider: new ReCaptchaV3Provider('6LcYfGUqAAAAAH2N7Ojwrvbr_cd0FL384rwOtQEH'),
    isTokenAutoRefreshEnabled: true,
  });
} catch (error) {
  console.warn('[Firebase] App Check initialization failed:', error);
}

/**
 * Returns true when an App Check token can be obtained right now.
 * With Firestore enforcement on, a missing token means every request will
 * be denied — callers use this to preflight before creating Auth accounts.
 */
export const isBotCheckAvailable = async () => {
  if (!appCheck) return false;
  try {
    await getAppCheckToken(appCheck);
    return true;
  } catch (error) {
    console.error('App Check token unavailable:', error);
    return false;
  }
};

export { auth, firestore, storage, googleProvider, appCheck }; // Export instances for use in your app
